

import { createTheme, Theme } from '@mui/material/styles';
import colors from "../colors";
// const defaultTheme = createTheme();
// console.log("defaultTheme",defaultTheme)
const theme: Theme = createTheme({
  typography: {
    button: {
      fontSize:15,
      fontWeight:"bold" as const,
      textTransform: "none" as const,
    },
    // @ts-ignore
    useNextVariants: true
  },

  palette: {
    mode: "light",

    success: {
      light: colors.buttonSuccess,
      main: colors.buttonSuccess,
      contrastText: "#fff"
    },
    info:{
      light: colors.buttonInfo,
      main: colors.buttonInfo,
      contrastText: "#fff"
    },
    secondary:{
      light: colors.buttonLight,
      main: colors.buttonLight,
      contrastText: "rgb(25, 118, 210)"
    },
    background: {
      default: "#fff",
      // paper: "#FCFCFC",
    },
  },

});

export default theme;
